import { render } from "./EditDonorQuestionnairePage.vue?vue&type=template&id=43490581"
import script from "./EditDonorQuestionnairePage.vue?vue&type=script&lang=js"
export * from "./EditDonorQuestionnairePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__